// extracted by css-extract-rspack-plugin
export default {"container":"src-app-components-forms-TelnumTextBox-TelnumTextBox-module__container-PhQtzO","transparent":"src-app-components-forms-TelnumTextBox-TelnumTextBox-module__transparent-cFzpgq","readonly":"src-app-components-forms-TelnumTextBox-TelnumTextBox-module__readonly-DRudzI","viewer":"src-app-components-forms-TelnumTextBox-TelnumTextBox-module__viewer-Q89PFq"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-app-components-forms-TelnumTextBox-TelnumTextBox-module__container-PhQtzO\",\"transparent\":\"src-app-components-forms-TelnumTextBox-TelnumTextBox-module__transparent-cFzpgq\",\"readonly\":\"src-app-components-forms-TelnumTextBox-TelnumTextBox-module__readonly-DRudzI\",\"viewer\":\"src-app-components-forms-TelnumTextBox-TelnumTextBox-module__viewer-Q89PFq\"}";
        // 1789362522816
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  